export default [
    {
      name: "Leo Allnet | Portfolio",
      id: 1,
      content:
      "Portfolio highlighting a client's works of art.",
      image:
      "https://leoallnet.fr/img/Allnet_logo.ec340ad6.jpg",
      tech1:
      "https://img.shields.io/badge/arduino-00979D?style=flat&logo=arduino&logoColor=white",
      tech2: 
      "https://img.shields.io/badge/php-blue",
      tech3:
        "https://img.shields.io/badge/js-yellow",
  
      live: "https://leoallnet.fr/",
      code: "https://leoallnet.fr/",
    },
  
    {
      name: "Le Vendangeoir | Restaurant éphémere à Vertus",
      id: 0,
      content:
      "E-commerce website for an ephemeral restaurant. You can book your time for a specific and unique menu, and also get a discount if you join to the association. ",
      image:
        "https://cdn.shopify.com/s/files/1/0789/7943/2793/files/20161103_MKB_9545.jpg?v=1699541553",
      tech1:
        "https://img.shields.io/badge/python-306998?style=flat&logo=python&logoColor=white",
      tech2:
        "https://img.shields.io/badge/django-092E20?style=flat&logo=django&logoColor=white",
      live: "https://vendangeoir.com/",
      code: "https://vendangeoir.com/"
    },

    
    {
      name: "Ablet | Table e-commerce ",
      id: 7,
      content:
      "E-commerce website about farm table. The goal is that you could custom your own table by using the custom tool available in the website.",
      image: "https://ablet.fr/cdn/shop/files/preview_images/untitled.jpg?v=1706107384&width=713",
      tech1:
      "https://img.shields.io/badge/python-306998?style=flat&logo=python&logoColor=white",
      tech2:
      "https://img.shields.io/badge/ROS-22314E?style=flat&logo=ROS&logoColor=white",
      tech3:
      "https://img.shields.io/badge/C-00599C?style=flat&logo=c&logoColor=white",
      live: "https://ablet.fr/",
      code: "https://ablet.fr/",
    },

    {
      name: "FPV DRONE VIDEO | Commercial use",
      id: 0,
      content:
      "Video of Website entrance | Vineyard of the Pernet & Pernet champagne house",
      image:
        "https://fiverr-res.cloudinary.com/images/t_main1,q_auto,f_auto,q_auto,f_auto/gigs/339370539/original/3d9d07c12f447a751eb56394ad43718c04ece58f/do-an-fpv-drone-promotion-video.jpg",
      tech1:
        "https://img.shields.io/badge/python-306998?style=flat&logo=python&logoColor=white",
      tech2:
        "https://img.shields.io/badge/django-092E20?style=flat&logo=django&logoColor=white",
      live: "https://champagne-pernet-pernet.com/",
      code: "https://champagne-pernet-pernet.com/"
    }

  ];